import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import withStyles from '@mui/styles/withStyles';

/**
 * BidmiiLinearProgress renders a styled linear progress bar component.
 * Supports both determinate (with progress value) and indeterminate modes.
 * Uses Material-UI's LinearProgress with custom styling for colors and appearance.
 *
 * @param {Object} props - Component props
 * @param {number} [props.progress] - Progress value (0-100) for determinate mode. If undefined, uses indeterminate mode
 * @param {string} [props.backgroundColor] - Background color for the progress bar track
 * @param {string} [props.color] - Color for the progress bar fill
 * @returns {JSX.Element} A styled LinearProgress component
 */
export default function BidmiiLinearProgress(props: $TSFixMe) {
  const Progress = withStyles((theme) => ({
    root: {
      height: 5,
    },
    colorPrimary: {
      backgroundColor: props.backgroundColor || theme.palette.secondary.main,
    },
    bar: {
      backgroundColor: props.color || theme.palette.blue.main,
      borderRadius: 50,
      opacity: '80%',
    },
  }))(LinearProgress);

  return (
    <Progress
      variant={props.progress ? 'determinate' : 'indeterminate'}
      value={props.progress}
    />
  );
}
